module.exports = __webpack_public_path__ + "static/image/loading.a51c5608d01acf32df728f299767f82b.gif";